import { IoC } from './ioc/ioc.class';

export class WebCoreIoCKeys {
    //IoCContainer
    public static IWebCoreIoCContainer: string = 'IWebCoreIoCContainer';

    //Settings
    public static IWebCoreSettings: string = 'IWebCoreSettings';
    public static IWebCoreSensitiveSettings: string = 'IWebCoreSensitiveSettings';

    //Implementations
    public static ITranslation: string = 'ITranslation';
    public static IUtils: string = 'IUtils';
    public static ISettingsStorage: string = 'ISettingsStorage';
    public static ISensitiveSettingsStorage: string = 'ISensitiveSettingsStorage';
    public static IDomErrorHandler: string = 'IDomErrorHandler';
    public static IGoogleAnalitics: string = 'IGoogleAnalitics';
    public static IWebsiteConstants: string = 'IWebsiteConstants';
    public static INotificationService: string = 'INotificationService';
    public static IEventHandler: string = 'IEventHandler';
    public static IRandomSentenceGenerator: string = 'IRandomSentenceGenerator';
    public static ISidebarManagerComponent: string = 'ISidebarManagerComponent';
    public static IAssetResolver: string = 'IAssetResolver';
    public static ISidebarCssProvider: string = 'ISidebarCssProvider';
}

//angular throws a infinite loop exception (maximum call stack size exceeded) if this is a normal export: 'export const IoCContainer: Container = new Container();'
//we define here, to avoid export default in the module/index.ts file
let InnerIoCContainer: IoC = new IoC();
export default InnerIoCContainer;
